<template>
  <div @click="imageOpening = !imageOpening" :class="{'image': twoRows,'images-row': !twoRows}" v-if="src != ''">
    <img class="task-image" :src="src" alt="">
    <div v-if="sources.length > 1" class="more-images-icon" @click="showFiles">
      <em class="fa fa-copy origin-icon"><span class="spacer">
        <span class="inner-images-counter">+{{ sources.length + files.length}}</span>
      </span></em>
    </div>
    <task-content
        :contentClass="true"
        :imageOpening="imageOpening"
        :task="task"
        :turnOff="true"
        :wordFilter="wordFilter"
        :preOpenTaskFromChart="false"
        :preOpenMeetingFromMsgCenter="false"
        :isClicked="true"
        @tagsFillter="tagsFillter"
        @updated="fetchTasks"
        @show_assign_inp="handleReplyPrepare"
        @clear_sets="clearReplySets"
        :assign-reply-to="assignReplyTo"
        :reply-status="replyStatus"
        :selectedMainTab="selectedTab"
        :query-object="{}"
        @changeToWaitingTabAfterCreatingATask="changeToWaitingTabAfterCreatingATask"
    ></task-content>
    <GalleryFiles
        :rowPosition="rowPosition"
        @closeGallery="closeGallery"
        v-if="sources.length"
        :sources="sources"
        :openGallery="openGallery"
    />
  </div>
</template>

<script>
import TaskContent from "./TaskContent";
import GalleryFiles from "./GalleryFiles.component";
export default {
  name: 'TaskCardsView',
  components: {
    TaskContent,
    GalleryFiles
  },
  data() {
    return {
      src: '',
      sources: '',
      imageOpening: false,
      openGallery: false,
      files: '',
    };
  },
  props: {
    rowPosition: {
      type: Boolean,
      required: true
    },
    twoRows: {
      type: Boolean,
      required: true
    },
    task: {
      type: Object,
      required: true
    },
    taskOpenedFromImg:{
      type: Number,
    },
    isClicked: {
      type: Boolean
    },
    preOpenTaskFromChart: {
      type: Boolean
    },
    preOpenMeetingFromMsgCenter: {
      type: Boolean
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    wordFilter: {
      type: String
    },
    assignReplyTo: {
      type: Array,
      default: () => []
    },
    replyStatus: {
      type: Array,
      default: () => ({
        id: 1,
        type: "REPLY",
        title: "Replied"
      })
    },
    queryObject: {
      type: Object
    }
  },
  mounted() {
    this.src = this.getSrc(this.task.content);
    this.sources = this.getSrc(this.task.content, true);
    this.sources.unshift(this.src);
    this.files = this.getSrc(this.task.content, true, true);
    this.files.map(file => {
      this.sources.push(file);
    })

  },
  methods: {
    closeGallery(){
      this.openGallery = !this.openGallery;
    },
    showFiles(e){
      e.stopPropagation();
      this.openGallery = true;
    },
    // return src string by default || return [] of sources if sources = true
    getSrc(data, sources = false, filesSrc = false){

      let splitedString = data.split("<");
      let files;
      if(filesSrc){
        files = splitedString
            .filter(i => i.startsWith("iframe"))
      }else{
        files = splitedString
            .filter(i => i.startsWith("img"))
      }

      //return default image if no images in tasks
      if(!files.length && !sources){
        return '';
      }
      //some shit line what return clean src
      if(!sources){
        return files[0].split('src="')[1].split('" class="')[0].split('">')[0];
      }

      if(sources){
        let smallSources = [];
        files = files.map((file, idx) => {
          if(idx < 1) return;
          file = file.split('src="')[1].split('" class="')[0].split('">')[0];
          smallSources.push(file);
        })
        return smallSources;
      }
    },
  },
}
</script>

<style scoped>
.more-images-icon{
  font-family: Verdana, Helvetica, Arial, sans-serif;
}
.image-show-row{
  position: absolute;
  display: flex;
  width: 100%;
  flex-direction: row;
}


.images-row{
  margin-left: .1rem;
  margin-top: .5rem;
  display: flex;
  height: 280px;
  width: 26.7rem;
  transition: .2s;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #d6d5d5;
  background-repeat: no-repeat;
  background-size: cover;
  transition: .2s;
  display: flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
}
.image{
  margin-left: .1rem;
  margin-top: .5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  height: 140px;
  width: 26.7rem;
  transition: .2s;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #d6d5d5;
  background-repeat: no-repeat;
  background-size: cover;
  transition: .2s;
  display: flex;
  overflow: hidden;
}

.images-row .more-images-icon{
  position: absolute;
  top: 14rem;
  background: #242424d6;
  border-radius: 50%;
  width: 5rem;
  height: 4rem;
  padding-left: .3rem;
  text-align: center;
  color: white;
  cursor: pointer;
  font-size: 2.5rem;
}

.images-row .more-images-icon .inner-images-counter{
  position: absolute;
  font-size: 1.2rem;
  top: 1.3rem;
  left: 2rem;
  color: #262626;
  z-index: 666;
}

.image .more-images-icon{
  position: absolute;
  top: 6rem;
  background: #242424d6;
  border-radius: 50%;
  width: 5rem;
  height: 4rem;
  padding-left: .3rem;
  text-align: center;
  color: white;
  cursor: pointer;
  font-size: 2.5rem;
}

.image .more-images-icon .inner-images-counter{
  position: absolute;
  font-size: 1.2rem;
  top: 1.3rem;
  left: 2rem;
  color: #262626;
  z-index: 666;
}
.image .task-image{
  max-width: 21rem;
  max-height: 11rem;
}

.images-row .task-image{
  max-width: 24rem;
  margin-top: 8rem;
}

.image img, .image .bottom-images{
  align-self: center;
}

.image:hover{
  border: 1px solid #6b6b6b;
}

.small-image:hover{
  border: 1px solid #6b6b6b;
}
</style>
